module.exports = __webpack_public_path__ + "static/media/keep-safe-tip04.6c2ddcd7.png";